import { getLightbox } from "./esm/wrapper-lightbox";
import { getCarousel } from "./esm/wrapper-carousel";
import { getYmapsConstructor } from "./esm/wrapper-ymapsv3";

window.wrappers = {};

window.wrappers.getLightbox = getLightbox;
window.wrappers.getCarousel = getCarousel;
window.wrappers.getYmapsConstructor = getYmapsConstructor;
